// extracted by mini-css-extract-plugin
export default {"page":"AccessPage_page__wzrtN","header":"AccessPage_header__zI+Lg","pane":"AccessPage_pane__g99W9"};